import { render, staticRenderFns } from "./MerchantImpower.vue?vue&type=template&id=4cc607ab&scoped=true&"
import script from "./MerchantImpower.vue?vue&type=script&lang=js&"
export * from "./MerchantImpower.vue?vue&type=script&lang=js&"
import style0 from "./MerchantImpower.vue?vue&type=style&index=0&id=4cc607ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc607ab",
  null
  
)

export default component.exports